import styled from 'styled-components';

export const CompareChangesWrapper = styled.div<{$stacked?: boolean}>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-right: ${p => (p.$stacked ? '0' : 'auto')};
`;

export const ChangesTexts = styled.div<{$stacked?: boolean}>`
  display: flex;
  flex-direction: ${p => (p.$stacked ? 'column' : 'row')};
  gap: ${p => (p.$stacked ? '4px' : '8px')};
  justify-content: ${p => (p.$stacked ? 'space-between' : 'initial')};
  align-items: ${p => (p.$stacked ? 'baseline' : 'center')};
`;

export const EndIcon = styled.div<{$stacked?: boolean}>`
  display: flex;
  align-items: center;
  margin-left: ${p => (!p.$stacked ? '0' : 'auto')};
`;
